﻿window.cObjetFormulaireMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetTableUpdateLib = function () { return ["formulaire"] }

    this.mGetLibBase = function () { return "Formulaire"; }
    this.mGetAttributBase = function () { return "le" }
    this.mGetNewLib = function () { return "Nouveau formulaire"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { txt = ((objet.data.objet) ? objet.data.objet : "(aucun titre pour le formulaire)") }
        else {
            txt = "formulaire"
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        if (typeof dataTemplate == 'undefined') { return $("<i class='fafa fafa-formulaire' title='Formulaire'></i>"); }
        else {
            var $Icone = $("<i class='fafa fafa-formulaire' style='position:relative'></i>");
            if (dataTemplate.fini == "1") {
                $("<i class='fas fa-paper-plane dx-theme-accent-as-text-color' style='position:absolute;bottom:-2px;right:-2px;font-size:60%;'></i>").appendTo($Icone)
                $Icone.attr("title", "Formulaire terminée")
            } else {
            }
            return $Icone
        }
    }


    this.mGetItemTemplateHeight = function (type) {
        return 55
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

    }

    this.mGetNomFromTemplate = function (dataTemplate) {
        return dataTemplate.nom
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        if (dataTemplate.fini == "1") { contentElement.parent().addClass("texture_import_disable_projet_pipeline") }
        else { contentElement.parent().removeClass("texture_import_disable_projet_pipeline") }

        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)

        var $TdNom = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;'></td>").appendTo($Tr)
        var $Span = $("<span style='font-weight:bold;'>" + (dataTemplate.nbre_reponse == null ? "0" : dataTemplate.nbre_reponse + "") + " <i class='fas fa-reply'></i></span>").appendTo($TdNom)
        $Span.attr("title", (dataTemplate.nbre_reponse == null ? "aucune réponse" : dataTemplate.nbre_reponse + " réponse" + (dataTemplate.nbre_reponse>1 ? "s":"")) + " au formulaire")
        $("<span> &bull; </span>").appendTo($TdNom)
        var $Span = $("<span>" + ((dataTemplate.objet == null) ? "(aucun nom de formulaire)" : dataTemplate.objet) + "</span>").appendTo($TdNom)
        $Span.attr("title", ((dataTemplate.objet == null) ? "(aucun nom de formulaire)" : dataTemplate.objet))
        //var $TdNom = $("<td style='width:25%;text-overflow:ellipsis;overflow:hidden;'>Nb rep.: <span style='font-weight:bold;'>" + (dataTemplate.nbre_reponse == null ? "0" : dataTemplate.nbre_reponse + "") + "</span></td>").appendTo($Tr)

        var $DivUrl = $("<div style='width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;opacity:0.5;font-size:14px;'/>").appendTo(contentElement)
        var url = this.mGetUrlLinkWithDataTemplate(dataTemplate)
        var $SpanLink = $("<span class='state-hover dx-theme-accent-as-text-color' style='font-size:100%;opacity:1;padding-right:5px;'></span>").appendTo($DivUrl)
        $SpanLink.attr("title", "Cliquer pour copier l'adresse dans le presse-papier")
        $SpanLink.html("<i class='fas fa-copy'></i>")
        $SpanLink.on("click", function (e) {
            e.stopPropagation()
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val(url).select();
            document.execCommand("copy");
            $temp.remove();
            mNotify("L'adresse du formulaire a été copiée dans le presse-papier", "success", 6000)
        })
        var $a = $("<a href='javascript:void(0)' style='font-family:barlow condensed;'>" + url + "</a>").appendTo($DivUrl)
        $a.attr("title", url + "<br/>Partagez ce lien pour donner l'accès à votre formulaire.")
        if (this.isDirectory) {
            $a.on("click", function (e) {
                e.stopPropagation()
                window.open(url, "_blank")
            })
        }

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus, option) {
        if (dataPlus.dcr.toDateIlya(true) == dataPlus.dmo.toDateIlya(true)) {
            $("<span style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        } else {
            $("<span style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "<br/>Modifié le " + dataPlus.dmo.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "<br/><i class='fas fa-pen dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dmo.toDateIlya(true) + "</span>").appendTo(contentElement)
        }
    }

    this.mShowNewFormulaire = function (optionPopup) {
        var obj = Me.objet.bddRef.getObjet(Me.objet.bddRef.getObjet("formulaire").mGetNewData())
        obj.data.id_utilisateur = Me.objet.bddRef.utiCourant.id_utilisateur
        obj.mSave(function () { obj.mShowPopup() })
    }

    this.isPopupFullScreen = false
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        var dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentFormulaire({
            bddCtrl: objet.bddRef,
            data: objet.data,
            optionPopup: option
        }).dxCtrlContentFormulaire("instance")
    }

    this.mGetWidthPopup = function () { return 700 }
    this.mGetFullScreenPopup = function () { return false }

    this.mGetPopupPositionWidthHeight = function () {
        return {
            width: "calc(100% - 60px)",
            maxWidth: "calc(100% - 60px)",
            height: "calc(100% - 90px)",
            maxHeight: "calc(100% - 50px)",
            position: {
                my: "right top",
                at: "right top",
                of: "body",
                offset: { x: -30, y: 65 }
            }
        }
    }

    this.mGetLookUpForFilterBuilder = function () {
        return {
            dataSource: objet.bddRef.mGetArray("formulaire"),
            searchEnabled: true,
            searchExpr: "nom",
            displayExpr: "nom",
            valueExpr: "id_formulaire",
            placeholder: "Sélectionnez des formulaires"
        }
    }

    this.mGetUrlLink = function () {
        //https://xxxxx.xxxxxx.eu/nom_base/id_formulaire/id_table_dest/id_dest/id_formulaire_reponse/ignore/form
        var url = parametre.url_appli.replace("app.", "appgo.") + "/" + objet.bddRef.nom_base + "/" + objet.data.id_formulaire + "/xXidtabdestXx/xXiddestXx/0/0/form"
        return url
    }

    this.mGetUrlLinkWithDataTemplate = function (dataTemplate) {
        //https://xxxxx.xxxxxx.eu/nom_base/id_formulaire/id_table_dest/id_dest/id_formulaire_reponse/ignore/form
        var url = parametre.url_appli.replace("app.", "appgo.") + "/" + objet.bddRef.nom_base + "/" + dataTemplate.id_formulaire + "/xXidtabdestXx/xXiddestXx/0/0/form"
        return url
    }

    this.mGetUrlLinkPrint = function (idFormulaireReponse = null) {
        //https://xxxxx.xxxxxx.eu/nom_base/id_formulaire_reponse/formulaireprint
        var url = parametre.url_appli.replace("app.", "appgo.") + "/" + objet.bddRef.nom_base + "/" + objet.data.id_formulaire + "/" + (idFormulaireReponse ? idFormulaireReponse : "0") + "/formulaireprint"
        return url
    }

}